/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/view-field-value-renderer/shop.view-field-value-renderer.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {Artikel} from '../../../../models/artikel';
import {BehaviorSubject} from 'rxjs';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {AppConfigService} from '../../../../services/app.config.service';
import {View} from '../../../../models/view';
import {Warenkorb} from '../../../../models/warenkorb';

/**
 * Zweck: Beschreibt class ShopViewFieldValueRendererComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'view-field-value-render',
    templateUrl: 'shop.view-field-value-renderer.component.html',
    styleUrls: ['shop.view-field-value-renderer.component.scss'],
    standalone: false
})
export class ShopViewFieldValueRendererComponent implements OnInit, OnChanges {
  @Input() fieldname: string;
  @Input() mode = 'table';
  @Input() artikel: Artikel;
  @Input() view: View;
  @Input() viewcomp: any;
  @Input() nowrap = true;
  @Input() current_warenkorb: Warenkorb;
  @Input() append_if_not_empty: string;

  baseUrl: string;

  show_uvp = new BehaviorSubject<boolean>(false);

  tooltip = new BehaviorSubject<string>(null);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public wksvc: AppWarenkorbService, public cfg: AppConfigService, private cd: ChangeDetectorRef) {
    this.baseUrl = this.cfg.buildApiUrl('/');
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.artikel) {
      this.detectChanges();
    }
  }
  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

/**
 * Beschreibt Methode isInOtherWarenkorb und ihren Rückgabevertrag.
 */
  isInOtherWarenkorb() {
    if (this.current_warenkorb) {
      return false;
    } else {
      return false;
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    if (this.artikel && !this.view && this.artikel.view) {
      this.view = this.artikel.view;
    }
    if (this.fieldname == 'einkaufspreis') {
      if (this.cfg.domainconfig.features.includes('UVP') && this.view && this.view && this.view.settings && this.view.settings.show_uvp) {
        this.show_uvp.next(true);
      } else {
        this.show_uvp.next(false);
      }
    } else if (this.fieldname == 'boxerstattungskodex') {
      switch (this.artikel.BoxErstattungskodex) {
        case 'N':
          this.tooltip.next('No Box');
          break;

        case 'Y':
          this.tooltip.next('Gelbe Box');
          break;

        case 'R':
          this.tooltip.next('Rote Box');
          break;

        case 'G':
          this.tooltip.next('Grüne Box');
          break;
      }
    }
  }
}
